import { Controller } from 'react-hook-form';
import { InputBase, MenuItem, Select, TextField } from '@mui/material';
import { WHITE } from 'utilities/colors';
import {
  DISPLAYED_METADATA_LABELS,
  STAIN_TYPES,
} from 'components/OrderSlidesList/SlideActionTabs/constants';

export const MetadataEditableField = ({ label, value, control, classes }) => {
  const isStainType = label === DISPLAYED_METADATA_LABELS.stainType;

  return (
    <Controller
      name={label}
      control={control}
      defaultValue={value}
      render={({ field }) =>
        isStainType ? (
          <Select
            {...field}
            className={classes.editableSelect}
            input={<InputBase className={classes.customInput} />}
            variant="outlined"
          >
            {STAIN_TYPES.map(({ name, displayName }) => (
              <MenuItem key={name} value={name}>
                {displayName}
              </MenuItem>
            ))}
          </Select>
        ) : (
          <TextField
            variant="outlined"
            {...field}
            classes={{ root: classes.root }}
            InputProps={{
              style: { height: '1.75rem', backgroundColor: WHITE },
            }}
          />
        )
      }
    />
  );
};
